import { jsx, jsxs } from "react/jsx-runtime";
import { Bleed, Box, Text, IconRenderer } from "braid-design-system";
import { badgeVerifiedCredentialStyle } from "./BadgeVerifiedCredentials.css.mjs";
const verticalPadding = "xxsmall";
const BadgeVerifiedCredentials = ({
  children,
  bleedY = false
}) => {
  const content = /* @__PURE__ */ jsx(Box, { component: "span", display: "flex", cursor: "default", children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      paddingY: verticalPadding,
      paddingX: "xsmall",
      borderRadius: "standard",
      overflow: "hidden",
      className: badgeVerifiedCredentialStyle,
      children: /* @__PURE__ */ jsxs(Text, { size: "xsmall", weight: "medium", maxLines: 1, children: [
        /* @__PURE__ */ jsx(IconRenderer, { children: ({ className }) => /* @__PURE__ */ jsxs(
          "svg",
          {
            width: "1",
            height: "1",
            viewBox: "0 0 12 9",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className,
            children: [
              className,
              /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_10088_99769)", children: [
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M4.09091 8.99995C4.02136 8.99995 3.95591 8.98359 3.89045 8.94677L0.208636 6.90132C0.0777273 6.82768 0 6.69268 0 6.54541V2.4545C0 2.30723 0.0818182 2.16814 0.208636 2.09859L3.89045 0.0531357C4.01318 -0.0164098 4.16454 -0.0164098 4.28727 0.0531357L7.96909 2.09859C8.1 2.17223 8.17773 2.30723 8.17773 2.4545V6.54541C8.17773 6.69268 8.09591 6.83177 7.96909 6.90132L4.28727 8.94677C4.22591 8.9795 4.15636 8.99995 4.08682 8.99995H4.09091ZM0.818182 6.30405L4.09091 8.1245L7.36364 6.30405V2.69586L4.09091 0.875408L0.818182 2.69586V6.30405Z",
                    fill: "#503DC9"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M3.68034 5.72725C3.57398 5.72725 3.4717 5.68634 3.38989 5.60862L2.28125 4.49998L2.85807 3.92316L3.67625 4.74134L5.31261 3.10498L5.88943 3.6818L3.96261 5.60862C3.8808 5.69043 3.77852 5.72725 3.67216 5.72725H3.68034Z",
                    fill: "#503DC9"
                  }
                )
              ] }),
              /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_10088_99769", children: /* @__PURE__ */ jsx("rect", { width: "8.18182", height: "9", fill: "white" }) }) })
            ]
          }
        ) }),
        children
      ] })
    }
  ) });
  return bleedY ? /* @__PURE__ */ jsx(Bleed, { component: "span", vertical: verticalPadding, children: content }) : content;
};
BadgeVerifiedCredentials.__isBadge__ = true;
export {
  BadgeVerifiedCredentials
};
